/**
 * Freshdesk detail shell - one header + tab strip over an `<Outlet/>`. Tabs are
 * react-router links so right-click / ctrl-click "open in new tab" works
 * (MANDATORY nav rule). Ships with one tab (Status); downstream KB / contacts /
 * ticket-count plans append to the `TABS` array.
 */
import React, { useMemo } from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import { Link as RouterLink, Outlet, useLocation } from 'react-router-dom'

import AdminPageHeader from '../../../../../components/admin/shared/AdminPageHeader'
import { FreshdeskIcon } from '../../../../../components/SystemIcons'
import { poolwerxColors } from '../../../../../theme/colors'

const BASE = '/admin/system/integrations/freshdesk'

const TABS = [
  { label: 'Status', path: BASE },
  { label: 'Solutions', path: `${BASE}/solutions` },
  { label: 'Companies', path: `${BASE}/companies` },
]

const FreshdeskLayout: React.FC = () => {
  const location = useLocation()

  const activePath = useMemo(() => {
    const match = TABS.filter((t) => location.pathname === t.path)
    return match.length ? match[0].path : BASE
  }, [location.pathname])

  return (
    <Box>
      {/* Tighten the gap below the title/subtitle without dropping the subtitle
          (which `dense` would). */}
      <AdminPageHeader
        pageKey="freshdeskIntegration"
        sx={{ mb: 2 }}
        iconOverride={<FreshdeskIcon size={24} />}
      />

      <Tabs
        value={activePath}
        sx={{
          mb: 2,
          borderBottom: 1,
          borderColor: 'divider',
          '& .MuiTabs-indicator': { backgroundColor: poolwerxColors.teal },
          '& .Mui-selected': { color: `${poolwerxColors.teal} !important` },
        }}
      >
        {TABS.map((t) => (
          <Tab
            key={t.path}
            value={t.path}
            label={t.label}
            component={RouterLink}
            to={t.path}
          />
        ))}
      </Tabs>

      <Outlet />
    </Box>
  )
}

export default FreshdeskLayout
